import { useContext } from "react";

import { notificationContext } from "../../context/context";
import { getToastStyle } from "../../utils/toastUtils";

function Toast() {
  const { toast, clearToast } = useContext(notificationContext);

  return (
    <div className="toast-wrapper">
      {toast?.map((data) => (
        <div
          className={`toast-container ${getToastStyle(data.type)}`}
          id={data?.id}
        >
          <div className="list-item">
            <div className="list-icon">
              <span class="material-symbols-rounded">info</span>
            </div>
            <div className="list-details">{data?.content}</div>
            <div className="list-icon" onClick={() => clearToast(data?.id)}>
              <span class="material-symbols-rounded">close</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Toast;
